import { createConfig } from "@Utils/createConfig";
import { gatewayUrl } from "@Constants/gatewayUrl";
import axios from "axios";
export async function updateSavedPrompt(token, id, prompt) {
    const header = createConfig(token);
    const url = `${gatewayUrl}/chats/promptBank/${id}`;
    const body = {
        title: prompt.title,
        prompt: prompt.prompt,
        isFavourite: prompt.isFavourite,
        isPrivate: prompt.type && prompt.type !== "juristic" ? prompt.type === "private" : undefined
    };
    try {
        const response = await axios.patch(url, body, header);
        return response.data;
    } catch (error) {
        console.error("Error updating saved prompt:", error);
        throw new Error("Failed to update saved prompt");
    }
}
